// extracted by mini-css-extract-plugin
export default {"page":"BE","wrapper":"CE","text":"EE","icons":"FE","icon":"GE","icon_text":"HE","carousel_wrapper":"IE","slide":"JE","image":"KE","arrows":"LE","prev":"ME","modal_root":"NE","x_mark":"OE","modal":"PE","images":"QE","main_image":"RE","name":"SE"};
    if(module.hot) {
      // 1713912566041
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  